import { ButtonBase } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Button = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(({ theme, active }) => {
  const isDark = theme.palette.mode === "dark";
  const { text, background, grey } = theme.palette;

  return {
    gap: theme.spacing(0.75),
    height: 32,
    padding: theme.spacing(0, 1.25),
    borderRadius: 999,
    backgroundColor: active ? text.primary : "transparent",
    color: active ? background.paper : text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1,
    whiteSpace: "nowrap",
    flexShrink: 0,
    transition: theme.transitions.create(["background-color", "color"], {
      duration: 150,
    }),

    "&:hover": {
      backgroundColor: active
        ? alpha(text.primary, 0.85)
        : grey[isDark ? 900 : 100],
    },
  };
});
